const defaultState = {
    language: navigator.language,
    userTheme: 'light',
    novaStatus: 'sleeping',
    fetchStatus: false,
    warningTriggered: false,
    userText: '',
    responseText: ''
};
export default defaultState;
